<script>
import Layout from "@/views/layouts/main";
import PageHeader from "@/components/Page-header";
import ScoreTableModal from "@/components/ScoreTableModal";

/**
 * Starter component
 */
export default {
  head () {
    return {
      title: `${this.title} | Minton - Nuxtjs Responsive Admin Dashboard Template`,
    };
  },
  data () {
    return {
      title: "題目答題紀錄",
      items: [
        {
          text: "法語鸚鵡螺",
          href: "/",
        },
        {
          text: "單元答題紀錄",
          href: "/users/records/unit/list",
        },
        {
          text: "題目答題紀錄",
          active: true,
        }
      ],
      pluginItem: {
        title: '',
        des: ''
      },
      searchMonth: null,
      themeId: false,
      topicId: "0",
      memberData: {},
      records: [],
      topics: [],
      playing: false,
      historySecondByMonth: 0,
      currentPage: 1,
      totalRows: 1,
      perPgae: 15,
      selectedRecord: null,
    };
  },
  components: {
    Layout,
    PageHeader,
    ScoreTableModal,
  },
  created () {
    this.themeId = this.$route.params.itemId
    this.getPluginTopics()
    this.getUnitRecords()
  },
  watch: {
    currentPage (_page) {
      this.getUnitRecords()
    },
    topicId (_topicId) {
      this.currentPage = 1
      this.getUnitRecords()
    }
  },
  methods: {
    getPluginTopics () {
      this.$root.apis.getPluginTopics(this.themeId, this.processSearchPluginTopics)
    },
    processSearchPluginTopics (_response) {
      this.topics = _response.body.items
    },
    getUnitRecords () {
      this.$root.apis.getUnitRecords(this.themeId, this.topicId, this.currentPage, this.processSearchUnitRecords)
    },
    processSearchUnitRecords (_response) {
      this.records = _response.body.items
      this.currentPage = _response.body.page
      this.totalRows = _response.body.total
      this.perPgae = _response.body.per_page
    },
    playAudio (url, onEndedCallback = null) {
      console.log("播放指定檔案:", url);
      const audio = new Audio(url);

      // 播放結束事件
      if (typeof onEndedCallback === 'function') {
        audio.addEventListener('ended', onEndedCallback);
      }

      this.playing = true

      audio.play().catch(error => {
        console.error("無法播放音訊：", error);
      });
    },
    playStop () {
      this.playing = false
    },
    showScoreModal (record) {
      this.selectedRecord = record
      this.$bvModal.show('score-table-modal')
    }
  }
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row">
      <div class="col-md-6 col-sm-12">
        <b-card>
          <div class="row">
            <div class="col-12">
              <div class="text-area">單元題目:</div>
              <div class="text-area">
                <select class="form-control" v-model="topicId">
                  <option value="0">全部題目</option>
                  <option v-for="topic in topics" :value="topic.id">{{ topic.title }} ({{ topic.des }})</option>
                </select>
              </div>
            </div>
          </div>
        </b-card>
      </div>
    </div>

    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="table-responsive">
              <table class="table table-borderless mb-0">
                <thead class="thead-light">
                  <tr class="text-center">
                    <th>項次</th>
                    <th>題目類型</th>
                    <th>單元名稱</th>
                    <th>題目名稱</th>
                    <th>測試時間</th>
                    <th>用戶信箱</th>
                    <th>錄音時間</th>
                    <th>用戶聲音</th>
                    <th>評分</th>
                    <th>結果</th>
                  </tr>
                </thead>
                <tbody v-if="!records.length">
                  <tr>
                    <td colspan="9" class="text-center">無資料</td>
                  </tr>
                </tbody>
                <tbody v-else>
                  <tr v-for="(record, index) in records">
                    <td class="text-center">{{ index + 1 }}</td>
                    <td class="text-center">
                      <span class="badge badge-soft-success" v-if="record.topicType == 1">單詞</span>
                      <span class="badge badge-soft-success badge-soft-warning" v-if="record.topicType == 2">句子</span>
                    </td>
                    <td class="text-left">{{ record.themeName }}</td>
                    <td class="text-left">{{ record.topicName }}</td>
                    <td class="text-center">{{ record.testAt }}</td>
                    <td class="text-center">{{ record.userEmail }}</td>
                    <td class="text-center">{{ $root.common.getTimeHourAndMin(record.seconds) }}</td>
                    <td class="text-center">
                      <b-button v-if="!playing" size="sm" variant="success"
                        @click="playAudio($root.mediaUri + record.voice, playStop)">
                        <i class="fe-play"></i>
                      </b-button>
                      <b-spinner v-else small variant="secondary" role="status"></b-spinner>
                    </td>
                    <td class="text-center">{{ record.total_score }} / 100</td>
                    <td class="text-center">
                      <b-button v-if="record.rawData && record.rawData.text_score" size="sm" variant="info"
                        @click="showScoreModal(record)">
                        查看詳情
                      </b-button>
                      <span v-else class="text-muted">無數據</span>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
        <!-- end card -->
      </div>
      <!-- end col -->
    </div>

    <div class="row">
      <div class="col">
        <div class="dataTables_paginate paging_simple_numbers float-right">
          <ul class="pagination pagination-rounded">
            <!-- pagination -->
            <b-pagination v-model="currentPage" :total-rows="totalRows" :per-page="perPgae"></b-pagination>
          </ul>
        </div>
      </div>
    </div>

    <!-- 評分表格彈窗 -->
    <ScoreTableModal modal-id="score-table-modal"
      :modal-title="`${selectedRecord ? selectedRecord.topicName : ''} - 評分詳情`"
      :score-data="selectedRecord ? selectedRecord.rawData : null" />

  </Layout>
</template>
